import {
  DownloadLink,
  DownloadOrgClassesRequest,
  GetOrgClassesRequest,
  GetOrgClassesResponse,
  OrgClassDetails,
  OrgRefScope
} from "../../../../types/gqlTypes/graphql"
import {
  DOWNLOAD_ORG_CLASSES,
  GET_ORG_CLASSES,
  GET_CLASS
} from "./orgClassQueries"

import { executeQuerySideload } from "../../helpers/studyPlan"
import { apolloCubeClient } from "../../helpers/studyPlan/studyPlanApolloStatic"

export async function getOrgClasses(
  data: GetOrgClassesRequest
): Promise<GetOrgClassesResponse> {
  const response = await executeQuerySideload(GET_ORG_CLASSES, { data })
  return response.getOrgClasses
}

export async function downloadOrgClasses(
  data: DownloadOrgClassesRequest
): Promise<DownloadLink> {
  const response = await executeQuerySideload(DOWNLOAD_ORG_CLASSES, { data })
  return response.downloadOrgClasses
}

export async function getClass(
  id: string,
  orgRefScope: OrgRefScope
): Promise<OrgClassDetails | null> {
  const { data } = await apolloCubeClient.query({
    query: GET_CLASS,
    variables: { id, orgRefScope },
    fetchPolicy: "network-only" // Always fetch fresh data
  })

  return data?.getClass || null
}
